module.exports = {"name":"pluginListActions","audiences":["alphaMembers"],"experimentAllocation":1,"defaultWeight":1,"experimentVersion":"v1","defaults":{"enabled":false},"autoTrack":true,"variations":[{"name":"enabled","weight":0,"values":{"enabled":true}}]}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/lib/experiments/config/pluginListActions.json
// module id = ikyV
// module chunks = 2